<template>
    <div class="card">
        <div class="card-body p-0">
            <div :class="{'opacity-03': !sale.status}">
                <div class="p-2" style="background-color: rgb(248, 250, 255);">
                    <div style="line-height: 1" class="text-muted small">{{ sale.affiliate_program.category_name }}</div>
                    <div style="line-height: 1" class="">{{sale.affiliate_program.name}}</div>
                    <div class="text-muted small d-flex justify-content-between">
                        <div class="">{{sale.affiliate_program.company.name}}</div>
                        <div class=""><span v-if="sale.affiliate_program.sale_amount > 0">Продажа:{{ (sale.affiliate_program.sale_amount / 100) | formatNumber }}</span> КВ: {{ sale.affiliate_program.fee_percent }}%</div>
                    </div>
                </div>
                <el-row :gutter="12" class="p-2">
                    <el-col :span="12">
                        № {{sale.document_number ? sale.document_number : '—'}}
                    </el-col>
                    <el-col :span="12" class="text-right">
                        от {{sale.document_date ? formatDate(sale.document_date) : '—'}}
                    </el-col>
                    <el-col :span="12">
                        <span class="text-muted">Сумма продажи</span>
                    </el-col>
                    <el-col :span="12" class="text-right">
                        <span>{{(sale.sale_amount / 100) | formatNumber}}</span>
                    </el-col>

                    <el-col :span="12">
                        <span class="text-muted">КВ</span>
                    </el-col>
                    <el-col :span="12" class="text-right">
                        <span>{{(sale.fee_amount / 100) | formatNumber}}</span>
                    </el-col>
                    <el-col :span="12">
                        <span class="text-muted">Оформил</span>
                    </el-col>
                    <el-col :span="12" class="text-right">
                        <span>{{sale.manager.name}}</span>
                    </el-col>
                    <el-col v-if="$hasPermission('affiliate_sales.update')" :span="24" class="text-right">
                        <button type="button" class="btn btn-sm btn-link pr-0" @click="openEditModal">Редактировать</button>
                    </el-col>
                </el-row>
            </div>
        </div>
        <ModalEdit v-if="editVisible" :visibleModal.sync="editVisible" @saved="onSaved" :affiliate-sale-id="sale.id" />
    </div>
</template>

<script>
import ModalEdit from "../affiliate_sales/ModalEdit";
export default {
    name: "AffiliateSaleItem",
    components: {ModalEdit},
    props: ['sale'],
    data: () => ({
        editVisible: false,
    }),
    methods: {
        formatDate(value) {
            return moment(value).format('DD.MM.YYYY');
        },
        openEditModal() {
            this.editVisible = true;
        },
        onSaved() {
            this.$emit('saved');
        }
    }
}
</script>

<style scoped>

</style>
